import React, { FC } from 'react';
import classnames from 'classnames';

export interface CarouselIndicatorProps {
  count?: number;
  activeIndex: number;
  className?: string;
}

export const CarouselIndicator: FC<CarouselIndicatorProps> = ({
  count = 0,
  activeIndex,
  className,
}) => (
  <div className={classnames(className, 'be-carrousel-indicator')}>
    {Array(count)
      .fill(undefined)
      .map((_, index) => {
        const key = index;
        return (
          <div
            key={key}
            className="be-carrousel-indicator__bar-wrapper tw:bg-disabled"
          >
            <div
              className={classnames('be-carrousel-indicator__bar', {
                'be-carrousel-indicator__bar--passed': activeIndex > index,
                'be-carrousel-indicator__bar--active': activeIndex === index,
              })}
            />
          </div>
        );
      })}
  </div>
);
